import { PascalsTriangleParams, PascalsTriangleRowHighlight } from './pascals-triangle.model';

// ---------------------------------------------------------------------------
// Basic triangle presets
// ---------------------------------------------------------------------------

export const PASCALS_TRIANGLE_DEFAULT: PascalsTriangleParams = {
  rows: 11,
};

export const PASCALS_TRIANGLE_SMALL: PascalsTriangleParams = {
  rows: 6,
};

export const PASCALS_TRIANGLE_LARGE: PascalsTriangleParams = {
  rows: 15,
};

// ---------------------------------------------------------------------------
// Story-aligned composite presets (matching the story host inputs)
// ---------------------------------------------------------------------------

export const PASCALS_TRIANGLE_DEFAULT_PRESET = {
  params: PASCALS_TRIANGLE_DEFAULT,
  height: 520,
  selectable: true,
};

export const PASCALS_TRIANGLE_SMALL_PRESET = {
  params: PASCALS_TRIANGLE_SMALL,
  height: 300,
  selectable: true,
};

export const PASCALS_TRIANGLE_NOT_SELECTABLE = {
  params: PASCALS_TRIANGLE_DEFAULT,
  height: 520,
  selectable: false,
};

export const PASCALS_TRIANGLE_EXPLAIN_PRESET = {
  params: PASCALS_TRIANGLE_DEFAULT,
  explain: true,
  selectable: false,
  showRowSlider: true,
  showProperties: true,
  showExpansion: false,
};

export const PASCALS_TRIANGLE_BINOMIAL_EXPANSION = {
  params: PASCALS_TRIANGLE_SMALL,
  explain: true,
  selectable: false,
  showRowSlider: true,
  showProperties: true,
  showExpansion: true,
  showTree: true,
};

export const PASCALS_TRIANGLE_SLIDER_WITH_EXPANSION = {
  params: PASCALS_TRIANGLE_SMALL,
  explain: true,
  selectable: false,
  showRowSlider: true,
  showProperties: false,
  showExpansion: true,
  showTree: true,
};

export const PASCALS_TRIANGLE_SHOW_PARENTS = {
  params: PASCALS_TRIANGLE_SMALL,
  height: 300,
  selectable: false,
  showParents: true,
};

export const PASCALS_TRIANGLE_HIGHLIGHTED_ROWS_DATA: PascalsTriangleRowHighlight[] = [
  { row: 2, color: 'teal', label: '(a+b)^2' },
  { row: 3, color: 'amber', label: '(a+b)^3' },
  { row: 4, color: 'pink', label: '(a+b)^4' },
];

export const PASCALS_TRIANGLE_HIGHLIGHTED_ROWS = {
  params: { rows: 5 } satisfies PascalsTriangleParams,
  height: 300,
  selectable: false,
  highlightedRows: PASCALS_TRIANGLE_HIGHLIGHTED_ROWS_DATA,
};

// ---------------------------------------------------------------------------
// Preset registry
// ---------------------------------------------------------------------------

export const PASCALS_TRIANGLE_PRESETS: Record<string, Record<string, unknown>> = {
  default: PASCALS_TRIANGLE_DEFAULT_PRESET,
  small: PASCALS_TRIANGLE_SMALL_PRESET,
  'not-selectable': PASCALS_TRIANGLE_NOT_SELECTABLE,
  explain: PASCALS_TRIANGLE_EXPLAIN_PRESET,
  'binomial-expansion': PASCALS_TRIANGLE_BINOMIAL_EXPANSION,
  'slider-with-expansion': PASCALS_TRIANGLE_SLIDER_WITH_EXPANSION,
  'show-parents': PASCALS_TRIANGLE_SHOW_PARENTS,
  'highlighted-rows': PASCALS_TRIANGLE_HIGHLIGHTED_ROWS,
};
